// src/data/terms.js

const termsText = `
1. Acceptance of Terms
By checking the box and submitting this form, you (“Vendor”) agree to abide by these terms and conditions.

2. Vendor Eligibility
You represent that you are at least 18 years old, and you are the owner of this business.

3. Service Listing
– You grant MyEventMitra a non-exclusive right to list and advertise your services on our platform.
– You are solely responsible for the accuracy of your business information, pricing, and availability.

4. Compliance
You agree to comply with all applicable local, state, and federal laws if applicable .

5. Content Standards
– Any images, text, or media you upload must be owned by you or properly licensed.
– Content must not be defamatory, obscene, or infringe on third-party rights.

6. Fees & Payments
– MyEventMitra does not charge you for registration, but may in the future introduce service fees or subscription plans.
– All fees, if introduced, will be clearly communicated before you incur them.

7. Cancellation & Refunds
You are responsible for setting your cancellation and refund policies for bookings; communicate these clearly to clients.

8. Limitation of Liability
MyEventMitra is a referral platform and shall not be liable for any disputes, damages, or losses arising from your service delivery or transactions.

9. Indemnification
You agree to indemnify and hold harmless MyEventMitra, its officers, and employees from any claims or liabilities arising out of your services or breach of these terms.

10. Termination
MyEventMitra may suspend or terminate your vendor account at any time for violation of these terms, with or without notice.

11. Changes to Terms
We may update these terms from time to time. We’ll post changes on our site; continued use of the platform constitutes acceptance of the updated terms.

12. Contact Us
For questions about these terms, email info@myeventmitra.com.
`.trim();

export default termsText;